/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';
import { getEventId } from '@e180/domain/lib/event/util';

import SupportContactFormDumb from './SupportContactFormDumb';
import { contactSupport } from 'src/shared/app/authentication/action/support/supportContactActions';
import { getAuthenticationUsername } from 'src/shared/app/authentication/selector/base/appAuthenticationBaseSelectors';
import { throwFormikSubmissionError } from 'src/shared/app/base/form/util/formUtil';
import { getEventPublicData } from 'src/shared/domain/event/selector/eventSelectors';

import type { State } from 'src/shared/core/type/reduxTypes';

type Props = {
  isSupportContacted: boolean,
};

const mapStateToProps = (
  state: State,
  { isSupportContacted }: Props,
): Object => ({
  isSupportContacted,
  email: getAuthenticationUsername(state),
  // Used in `mergeProps` only
  event: getEventPublicData(state),
});

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (stateProps: Object, { dispatch }: Object): Object => {
  const { event } = stateProps;

  return {
    ...stateProps,
    handleSubmit(values: Object) {
      return dispatch(contactSupport(values, getEventId(event))).catch((e) =>
        throwFormikSubmissionError(e),
      );
    },
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(SupportContactFormDumb);
